import { render } from "./Stamboom.vue?vue&type=template&id=309cf636&scoped=true"
import script from "./Stamboom.vue?vue&type=script&lang=js"
export * from "./Stamboom.vue?vue&type=script&lang=js"

import "./Stamboom.vue?vue&type=style&index=0&id=309cf636&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309cf636"]])

export default __exports__